import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getPartnerReservation } from 'modules/accommodations/features/reservations/api';

export const useQueryPartnerReservation = (calculationId: string) => {
  const {
    data: partnerReservationData,
    isLoading: partnerReservationIsLoading,
    isError: partnerReservationIsError,
  } = useQuery(
    [QUERY_KEYS.RENTALS_ACCOMMODATION_PARTNER_RESERVATION, calculationId],
    () => getPartnerReservation(calculationId),
    { enabled: !!calculationId },
  );

  return { partnerReservationData, partnerReservationIsLoading, partnerReservationIsError };
};
